import { Box, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';
import { Switch } from '../../types';
import InstrumentDisplay from './InstrumentDisplay';
import SwitchDisplay from './SwitchDisplay';
import { InstrumentType } from '../analyzerDataSettings/types';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
};

interface Props {
  selectedInstrumentType: InstrumentType;
  handleInstrumentSelected: (instrumentId: any) => void;
  setSelectedInstrumentType: (...args: any) => void;
  setConnectDialogOpen: () => void;
  switches: Switch[] | undefined;
  selectedInstrumentId: number;
}

const InstrumentTabPanel = ({
  selectedInstrumentType,
  handleInstrumentSelected,
  setSelectedInstrumentType,
  setConnectDialogOpen,
  switches,
  selectedInstrumentId,
}: Props) => {
  const { data: modules } = useSystemModules({});
  const { data: analyzers } = useAnalyzers({});

  return (
    <Grid container item>
      <Grid container item sx={{ width: '100%' }} component={Paper}>
        <Grid container item justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Tabs
              value={selectedInstrumentType}
              onChange={setSelectedInstrumentType}
              aria-label='secondary tabs example'
            >
              <Tab value={0} label='Analyzers' />
              {modules?.SWITCHES && <Tab value={1} label='Switches' />}
            </Tabs>
          </Grid>
        </Grid>
        <TabPanel value={selectedInstrumentType} index={0}>
          <InstrumentDisplay
            handleInstrumentSelected={handleInstrumentSelected}
            openConnectDialog={setConnectDialogOpen}
            selectedInstrumentId={selectedInstrumentId}
          />
        </TabPanel>
        {modules?.SWITCHES && (
          <TabPanel value={selectedInstrumentType} index={1}>
            <SwitchDisplay
              handleInstrumentSelected={handleInstrumentSelected}
              openConnectDialog={setConnectDialogOpen}
              switches={switches}
              selectedInstrumentId={selectedInstrumentId}
            />
          </TabPanel>
        )}
        {selectedInstrumentType === InstrumentType.ANALYZER &&
          !!analyzers?.some(
            (unit) => unit.status === false && unit.enabled
          ) && (
            <Grid container item>
              <Typography sx={{ p: '1rem' }} color={grey[500]}>
                A unit may be lost because it has no active snapshots.
              </Typography>
            </Grid>
          )}
      </Grid>
    </Grid>
  );
};

export default InstrumentTabPanel;
